module.exports = __webpack_public_path__ + "static/optimizeProcess-1789457246dc8c6010bf96a8ef5f0bc5.png";